/*
SVG Sprite

Markup:
<svg class="{{ classes }}"
  role="img"
  aria-labelledby="title"
  focusable="false">
  <use
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xlink:href="{{ asseturl '/Static/theme/images/sprites.svg' }}#{{ default sprite modifier_class }}"></use>
</svg>

Weight: 30

Styleguide ale001.Components.SvgSprite
*/
const files = require.context(__dirname, false, /\.svg$/);
files.keys().forEach(files);



// WEBPACK FOOTER //
// ./project/client/src/site__vegkit/components/site/sprites/index.js